import { c as _c } from "react/compiler-runtime";
import type { JobExcerpt } from "@repo/design-system/types/job";
import { displayLocation, displayLocationShort } from "@repo/design-system/utils/display-location";
import { ShowMoreList } from "./show-more-list-eon";

/**
 * Display one or multiple locations for a job
 */
export function LocationDisplay(t0) {
  const $ = _c(15);
  const {
    job,
    showAll: t1,
    hideCountry: t2,
    hideState: t3,
    separator
  } = t0;
  const showAll = t1 === undefined ? false : t1;
  const hideCountry = t2 === undefined ? false : t2;
  const hideState = t3 === undefined ? false : t3;
  if (!job.data.locations || job.data.locations.length === 1) {
    let t4;
    if ($[0] !== hideCountry || $[1] !== hideState || $[2] !== job.data) {
      t4 = displayLocation(job.data, hideCountry, hideState);
      $[0] = hideCountry;
      $[1] = hideState;
      $[2] = job.data;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== t4) {
      t5 = <>{t4}</>;
      $[4] = t4;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    return t5;
  }
  let t4;
  if ($[6] !== hideState || $[7] !== job.data.locations) {
    let t5;
    if ($[9] !== hideState) {
      t5 = loc => displayLocationShort(loc, hideState);
      $[9] = hideState;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = job.data.locations.map(t5);
    $[6] = hideState;
    $[7] = job.data.locations;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = showAll ? Number.POSITIVE_INFINITY : 75;
  let t6;
  if ($[11] !== separator || $[12] !== t4 || $[13] !== t5) {
    t6 = <ShowMoreList list={t4} maxLength={t5} separator={separator} />;
    $[11] = separator;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}